import Accordion from '@components/Accordion/Accordion.vue'
import { mapState } from 'vuex'
import questionsData from './questions.json'

export default {
  name: 'ConnectDomainModal',
  props: {
    modalVisible: {
      required: true,
      type: Boolean,
    },
    targetPlatform: {
      required: true,
      type: String,
    },
  },
  components: {
    Accordion,
  },
  computed: {
    ...mapState({
      userToken: (state) => state.users.currentUser.apiKey,
    }),
    questions() {
      if (this.targetPlatform && questionsData[this.targetPlatform]) {
        return questionsData[this.targetPlatform].questions.map(q => ({
          question: q.question,
          answer: q.answer.replace('YOUR_TOKEN', this.userToken)
        }));
      } else {
        return [];
      }
    },
    supportLink() {
      if (this.targetPlatform && questionsData[this.targetPlatform]) {
        return questionsData[this.targetPlatform].supportLink;
      } else {
        return '';
      }
    },
    title() {
      if (this.targetPlatform && questionsData[this.targetPlatform]) {
        return questionsData[this.targetPlatform].title;
      } else {
        return '';
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
  },
}
